import MedicalClinicJsonLd from "@/components/feature/MedicalClinicJsonLd";
import FirstView from "./components/FirstView";
import QuickNav from "./components/QuickNav";
import FindByConcern from "./components/FindByConcern";
import MainTreatments from "./components/MainTreatments";
import SpecialTreatments from "./components/SpecialTreatments";
import PickUp from "./components/PickUp";
import AboutSbdc from "./components/AboutSbdc";
import WhySbdc from "./components/WhySbdc";
import PatientVoice from "./components/PatientVoice";
import MedicalPolicy from "./components/MedicalPolicy";
import Price from "./components/Price";
import ForFirstVisit from "./components/ForFirstVisit";
import FaqSection from "./components/FaqSection";
import InstagramSection from "./components/InstagramSection";
import Access from "./components/Access";
import FinalCta from "./components/FinalCta";

export default function Home() {
  return (
    <>
      <MedicalClinicJsonLd />
      <FirstView />
      <QuickNav />
      <FindByConcern />
      <MainTreatments />
      <SpecialTreatments />
      <PickUp />
      <AboutSbdc />
      <WhySbdc />
      <PatientVoice />
      <MedicalPolicy />
      <Price />
      <ForFirstVisit />
      <FaqSection />
      <InstagramSection />
      <Access />
      <FinalCta />
    </>
  );
}